import React, { forwardRef, LegacyRef } from 'react'
import styles from './Button.module.scss'
import cl from 'classnames'
import { ButtonProps } from './Button.types'

const ButtonComponent = (props: ButtonProps, ref: LegacyRef<HTMLButtonElement>) => {
  const {
    children,
    preset,
    className,
    // onClick,
    ...rest
  } = props

  // const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
  //   event.preventDefault()
  //   if (onClick) onClick()
  // }

  return (
    <button
      ref={ref}
      className={cl(styles.button, styles[preset], className)}
      // onClick={handleClick}
      {...rest}
    >
      {children}
    </button>
  )
}

const Button = forwardRef(ButtonComponent)
export { Button }
